import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileBase64 from 'react-file-base64';
import { resizeImage } from 'function/resizeImage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SubCard from 'ui-component/cards/SubCard';
import {
    Alert,
    Avatar,
    Box,
    Button,
    ButtonBase,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Collapse,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputBase,
    InputLabel,
    MenuItem,
    Pagination,
    Paper,
    Select,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import axios from 'axios';
import ApiLink from 'API';
import { useTheme } from '@mui/styles';
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PanoramaIcon from '@mui/icons-material/Panorama';
import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router';
import LoadingProduct from 'ui-component/cards/Skeleton/LoadingProduct';

const SelectPremium = ({ open, setOpen, openBackdrop, setopenBackdrop, setData }) => {
    const [Value, setValue] = useState('');
    const [page, setpage] = useState(1);
    const [totalPage, settotalPage] = useState(0);

    const handleClose = () => {
        setOpen(false);
    };
    const handlePage = (event, value) => {
        setpage(value);
    };
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const theme = useTheme();
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const scriptedRef = useScriptRef();
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });
    const [dataProduct, setdataProduct] = useState([]);
    // Which shelf the gifts are being taken from — and the one they will actually be
    // deducted from, because the chosen branch travels with the line to the server.
    //
    // Starts on the user's own branch: that is where the goods are, and it is what the order
    // deducted from before this choice existed. Another branch can be chosen deliberately,
    // and '' shows everything combined — but a combined view cannot say which shelf an item
    // would leave from, so picking is disabled there rather than guessing.
    const [locationCode, setLocationCode] = useState(localStorage.getItem('locationCode') || '');
    const [locations, setLocations] = useState([]);
    async function LoadProduct(ValueSearch) {
        try {
            setdataProduct([]);
            setopenBackdrop(true);
            const valueReplate = ValueSearch === '' ? '^' : ValueSearch.toLowerCase();

            // Was pinned to the user's own branch from localStorage, which is why gifts held
            // elsewhere never appeared. The shelf is chosen on screen now, and empty means all.
            const response = await axios.get(
                ApiLink + '/api/premiums/stock/all/' + valueReplate + '/' + page
                + (locationCode ? '?locationCode=' + encodeURIComponent(locationCode) : ''),
                {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setdataProduct(response.data.data);
                // settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }

            setopenBackdrop(false);
        }
    }
    // The branches to choose between. Failure is silent on purpose: not being able to list
    // them leaves the picker on "all locations", which still works.
    async function LoadLocations() {
        try {
            const res = await axios.get(ApiLink + '/api/consignment/all/^', {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (res.status === 200) setLocations(res.data.data || res.data || []);
        } catch (e) {
            /* leave the picker on all locations */
        }
    }

    useEffect(() => {
        LoadProduct(Value);
        LoadLocations();
    }, []);
    useEffect(() => {
        LoadProduct(Value);
    }, [page]);
    // Changing the shelf starts over at page one — page 3 of the whole company is not page 3
    // of one branch, and landing on an empty page reads as "this branch has nothing".
    useEffect(() => {
        if (page === 1) LoadProduct(Value);
        else setpage(1);
    }, [locationCode]);
    return (
        <div>
            <Dialog
                // fullScreen
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle1">Select Product</Typography>
                    {/* Which branch's shelf. Sits beside the title because it changes what the
                        whole list means, unlike the search box which only narrows it. */}
                    <TextField
                        select
                        size="small"
                        label="Location"
                        value={locationCode}
                        disabled={openBackdrop}
                        onChange={(e) => setLocationCode(e.target.value)}
                        sx={{ minWidth: matchDownSM ? 150 : 240 }}
                    >
                        <MenuItem value="">ທຸກສາຂາ / All locations (ເບິ່ງຢ່າງດຽວ / view only)</MenuItem>
                        {locations.map((l) => (
                            <MenuItem key={l.locationCode} value={l.locationCode}>
                                {l.locationCode}{l.Name ? ` — ${l.Name}` : ''}
                            </MenuItem>
                        ))}
                    </TextField>
                    <Box>
                        <Paper style={{ display: 'flex', width: matchDownSM ? 180 : 300 }} elevation={2}>
                            <InputBase
                                type="text"
                                fullWidth
                                disabled={openBackdrop}
                                style={{
                                    marginLeft: 1,
                                    flex: 1,
                                    fontFamily: 'boonhome-400'
                                }}
                                value={Value}
                                onChange={(event) => {
                                    setValue(event.target.value);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setpage(1);
                                        LoadProduct(Value);
                                    }
                                    // if (e.keyCode == 13) {
                                    //     setpage(1);
                                    //     // LoadData(Value);
                                    // }
                                }}
                                placeholder="ID, Name, Color"
                                inputProps={{ 'aria-label': 'ID, Name, Color' }}
                                startAdornment={
                                    <IconButton
                                        disabled={openBackdrop}
                                        className="iconbutton"
                                        aria-label="search"
                                        onClick={(e) => {
                                            setpage(1);
                                            LoadProduct(Value);
                                        }}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                }
                                endAdornment={
                                    <IconButton
                                        disabled={openBackdrop}
                                        className="iconbutton"
                                        aria-label="refresh"
                                        onClick={() => {
                                            // setData(dataOriginal);
                                            setValue('');
                                            LoadProduct('');
                                        }}
                                    >
                                        <RefreshIcon />
                                    </IconButton>
                                }
                            />
                        </Paper>
                    </Box>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ minHeight: '75vh', maxHeight: '75vh', mb: 2 }}>
                    <Collapse in={AlertBox.open}>
                        <Alert
                            sx={{ padding: '10px' }}
                            // variant="outlined"
                            severity={AlertBox.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertBox({ ...AlertBox, open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {AlertBox.message}
                        </Alert>
                    </Collapse>
                    <DialogActions
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        sx={{ display: 'flex', justifyContent: 'flex-start' }}
                    >
                        <Grid container spacing={1}>
                            <LoadingProduct show={openBackdrop} />
                            {dataProduct &&
                                dataProduct.map((params) => (
                                    <Grid item xs={12} sm={12} md={4} lg={4} align="center" key={params._id}>
                                        {/* <Button fullWidth>
                                            <Paper elevation={2} sx={{ overflow: 'hidden' }}> */}
                                        <Card
                                            elevation={2}
                                            sx={{ color: '#2196f3', opacity: locationCode ? 1 : 0.55 }}
                                        >
                                            <CardActionArea
                                                disabled={!locationCode}
                                                onClick={() => {
                                                    // console.log(params);
                                                    // No shelf chosen, no giving away: a
                                                    // combined view cannot say which branch
                                                    // the gift leaves from.
                                                    if (!locationCode) return;
                                                    if ((params?.premiumstocks?.in - params?.premiumstocks?.out || 0) !== 0) {
                                                        setData({
                                                            ...params,
                                                            amount: 1,
                                                            comment: '',
                                                            reference: '',
                                                            // Travels with the line and is what
                                                            // the server deducts from.
                                                            locationCode: locationCode
                                                        });
                                                    }
                                                    setOpen(false);
                                                }}
                                            >
                                                {/* <CardContent sx={{ height: 200 }}> */}
                                                <Box sx={{ display: 'flex', flexDirection: 'row', height: 180, padding: '5px' }}>
                                                    <Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            {params.img !== '' ? (
                                                                <Avatar
                                                                    src={params.img}
                                                                    sx={{
                                                                        width: 80,
                                                                        height: 80,
                                                                        backgroundColor: 'transparent'
                                                                    }}
                                                                    variant="rounded"
                                                                />
                                                            ) : (
                                                                <Avatar
                                                                    sx={{
                                                                        width: 100,
                                                                        height: 100,
                                                                        backgroundColor: '#fafafa'
                                                                    }}
                                                                    variant="rounded"
                                                                >
                                                                    <PanoramaIcon />
                                                                </Avatar>
                                                            )}

                                                            <Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1" noWrap>
                                                                        {params.premiumName}
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption" noWrap>
                                                                        ID:
                                                                    </Typography>
                                                                    <Typography variant="body2" noWrap>
                                                                        {params.premium_id}
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption" noWrap>
                                                                        Color:
                                                                    </Typography>
                                                                    <Typography variant="body2" noWrap>
                                                                        {params.color}
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption">{`ReferencePrice:`}</Typography>
                                                                    <Typography variant="body2" color="#f57224">
                                                                        <NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={params.referencePrice}
                                                                            prefix="₭"
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                        />
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption">{`Price:`}</Typography>
                                                                    <Typography variant="body1" color="#f57224">
                                                                        <NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={params.salePrice}
                                                                            prefix="₭"
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                        />
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption">{`ImportPrice:`}</Typography>
                                                                    <Typography variant="body2" color="#0c4da2">
                                                                        <NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={params.importPrice}
                                                                            prefix="₭"
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                        />
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption">{`Stock:`}</Typography>
                                                                    <Typography variant="body2" color="#0c4da2">
                                                                        {params.premiumstocks?.in - params.premiumstocks?.out || 0}
                                                                    </Typography>
                                                                </Stack>
                                                                {/* <Stack direction="row" spacing={1}>
                                                                    <Typography variant="caption" noWrap>
                                                                        Category:
                                                                    </Typography>
                                                                    <Typography variant="body2" noWrap>
                                                                        {params.categorys.categoryName}
                                                                    </Typography>
                                                                </Stack> */}
                                                            </Stack>
                                                        </Stack>

                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="caption" noWrap>
                                                                Description:
                                                            </Typography>
                                                            <Typography variant="body2">{params.description}</Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Box>
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    sx={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '15px' }}
                                                >
                                                    <Typography variant="caption" color="#0c4da2" noWrap>
                                                        {params.categorys.categoryName}
                                                    </Typography>
                                                </Stack>
                                                {/* </CardContent> */}
                                            </CardActionArea>
                                        </Card>
                                        {/* </Paper>
                                        </Button> */}
                                    </Grid>
                                ))}
                        </Grid>
                    </DialogActions>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Pagination
                            disabled={openBackdrop}
                            count={totalPage}
                            // variant="outlined"
                            page={page}
                            size="small"
                            shape="rounded"
                            color="primary"
                            onChange={handlePage}
                            showFirstButton
                            showLastButton
                        />
                    </Box>

                    <Button onClick={handleClose}>Cancel</Button>
                    {/* <Button onClick={handleClose}>Save</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default SelectPremium;
